exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".locationsPage{display:flex;flex-grow:1;justify-content:space-around;flex-wrap:wrap;padding-top:48px;padding-bottom:7rem}@media screen and (max-width: 960px){.locationsPage{padding:0 4vw 7rem 4vw}}\n", ""]);

// exports
